import { OrderDataLine } from '@zonofi/zono-money-store';
import { Divider } from '../../../components';
import './discount-modal.scss';
import { getCalculatedAmount } from '@zonofi/common/functions/format-amount';

const Strings = {
  QUANTITY: 'Quantity',
  PACK_SIZE: 'Pack Size:',
  BUYING_PRICE: 'Buying Price',
};

interface ItemLevelSummaryProps {
  data: OrderDataLine;
}

function ItemLevelSummary({ data }: ItemLevelSummaryProps) {
  return (
    <div className="discount-modal__item-summary">
      <div className="discount-modal__item-title font-semibold">
        {data?.title}
      </div>
      <div className="discount-modal__item-row">
        <div>
          <div className="discount-modal__item-label font-medium">
            {Strings.BUYING_PRICE}
          </div>
          <div className="discount-modal__item-value font-semibold">
            {getCalculatedAmount(String(data?.price))}
          </div>
        </div>
        <div>
          <div className="discount-modal__item-label font-medium">
            {Strings.QUANTITY}
          </div>
          <div className="discount-modal__item-value font-semibold">
            {data?.quantity || '0'}
          </div>
        </div>
      </div>
      <Divider className="discount-modal__divider" />
    </div>
  );
}

export { ItemLevelSummary };
